// Selector to get the tabs and active tab for a specific module
export const selectModuleTabs = (module) => (state) => {
    const moduleState = state[module] || {
      _version: '1.0', // Default version
      defaultTabs: [], // Default tabs (if not defined)
      dynamicTabs: [], // Dynamic tabs (if not defined)
      activeTab: 0, // Default active tab index
      selectedTemplate: null, // Selected template (only for messages slice)
    };

    return {
      tabs: [...moduleState.defaultTabs, ...moduleState.dynamicTabs], // Combine default and dynamic tabs
      activeTab: moduleState.activeTab, // Currently active tab index
      defaultTabsCount: moduleState.defaultTabs.length, // Number of default tabs
      selectedTemplate: moduleState.selectedTemplate, // Selected template (only for messages slice)
    };
  };